export const CONTAINER_ID = 'outbrain_widget_0';
export const CONTAINER_WRAP_ID = `${CONTAINER_ID}_wrap`;
export const CONTAINER_POSITION_TOP_OFFSET_EL_ID = `${CONTAINER_ID}_pos_top_offset`;
